import type { Size } from '../util';
import type { PlaneAxis } from './../dimension';
import { Vector } from './../vector';
import { linePlaneIntersection } from './geometry.util';

// Calibrated < -- > World
export function CalibratedToWorld(
	focalLength: number,
	planeCenter_MRW: Vector,
	planeNormal_MRW: Vector,
	resolution: Size,
	point_CI: Vector
): Vector {
	let line = {
		start: new Vector(),
		end: CalibratedToImage(resolution, point_CI),
	};

	line.end.z = focalLength;

	return linePlaneIntersection(line, planeCenter_MRW, planeNormal_MRW);
}

export function WorldToCalibrated(focalLength: number, resolution: Size, point_MRW: Vector): Vector {
	let point_IP = new Vector();

	let pz = point_MRW.z;
	point_IP.x = (point_MRW.x * focalLength) / pz;
	point_IP.y = (point_MRW.y * focalLength) / pz;

	return ImageToCalibrated(resolution, point_IP);
}

// Calibrated < -- > Image
export function CalibratedToImage(resolution: Size, point_CI: Vector): Vector {
	return new Vector(point_CI.x - resolution.width / 2, point_CI.y - resolution.height / 2);
}

export function ImageToCalibrated(resolution: Size, point_IP: Vector): Vector {
	return new Vector(point_IP.x + resolution.width / 2, point_IP.y + resolution.height / 2);
}

// Measure < -- > World
export function MeasureToWorld(planeOrigin_MRW: Vector, planeAxis_MP: PlaneAxis, point_MP: Vector): Vector {
	let point_MRW = planeOrigin_MRW;
	point_MRW = point_MRW.add(planeAxis_MP.x.multiply(point_MP.x));
	point_MRW = point_MRW.add(planeAxis_MP.y.multiply(point_MP.y));
	return point_MRW;
}

export function WorldToMeasure() {
	throw new Error('Not Yet Implemented!');
}

// Measure < -- > Calibrated
export function MeasureToCalibrated(
	focalLength: number,
	planeOrigin_MRW: Vector,
	planeAxis_MP: PlaneAxis,
	resolution: Size,
	point_MP: Vector
): Vector {
	let point_MRW = MeasureToWorld(planeOrigin_MRW, planeAxis_MP, point_MP);
	return WorldToCalibrated(focalLength, resolution, point_MRW);
}
